// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const blue = GlobalStyles.color.COLOR_SECONDARY;

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    margin: 15,
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down(650)]: {
      alignItems: 'center',
    },
  },
  noReverse: {
    flexDirection: 'row',
    [theme.breakpoints.down(650)]: {
      flexDirection: 'column',
    },
  },
  reverse: {
    flexDirection: 'row-reverse',
    [theme.breakpoints.down(650)]: {
      flexDirection: 'column',
    },
  },
  title: {
    display: 'flex',
    color: GlobalStyles.color.COLOR_PRIMARY,
    textShadow: `-1px 0 ${blue}, 0 1px ${blue}, 1px 0 ${blue}, 0 -1px ${blue}`,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: '4rem',
    [theme.breakpoints.down(650)]: {
      fontSize: '3rem',
    },
  },
  description: {
    width: 'fit-content',
    display: 'flex',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
    maxWidth: 200,
  },
  image: {
    height: 220,
    width: 300,
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 30px',
    [theme.breakpoints.down(650)]: {
      alignItems: 'center',
      marginTop: 20,
    },
  },
  leftType: {
    alignSelf: 'flex-start',
    [theme.breakpoints.down(650)]: {
      alignSelf: 'center',
    },
  },
  rightType: {
    alignSelf: 'flex-end',
    [theme.breakpoints.down(650)]: {
      alignSelf: 'center',
    },
  }
});

export default styles;
